import * as React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import MobileMenu from "./MobileMenu";
import {SEO} from "./SEO";

interface LayoutProps {
	title: string;
}

const Layout: React.FC<LayoutProps> = (props) => {
	const {children} = props;

	return (
		<>
			<SEO
				title={props.title}
			/>
			<div>
				<div className="block bg-white  md:hidden">
					<MobileMenu/>
				</div>
				<div className="hidden md:block">
					<Navbar/>
				</div>
				{children}
				<Footer/>
			</div>
		</>
	);
};

export default Layout;
